import { Component, OnDestroy, OnInit } from '@angular/core';

import { OGT } from '@atmi/core/models';
import { BaseICCDFormComponent } from '@atmi/shared/iccd/base-iccd-form.component';

@Component({
  selector: 'app-ogt-form',
  styleUrls: ['./ogt-form.component.scss'],
  templateUrl: './ogt-form.component.html',
})
export class OgtFormComponent extends BaseICCDFormComponent<OGT> implements OnDestroy, OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
